import React, { ComponentProps } from 'react';
import { Table } from '@datavant/uikit';
import { AddressConfirmationTableRow, columnDefs } from './Columns';

export const AddressConfirmationTable = ({
    table,
    isLoading,
}: {
    table: ComponentProps<typeof Table<AddressConfirmationTableRow>>['table'];
    isLoading: boolean;
}) => {
    return (
        <Table<AddressConfirmationTableRow>
            table={table}
            columnDefs={columnDefs}
            isLoading={isLoading}
            headerOptions={{ showExportButton: false, showRefreshButton: false }}
            footerOptions={{ hidePagination: true }}
        />
    );
};
